export const environment = {
    production: true,
    staging: true,
    isMockEnabled: true,
    authTokenKey: 'a209183b-a4ad-4ccb-a248-950987754774',
    salesforceKey: 'bd56ac38-bb85-4ecb-a37e-9cdfb767f2a9',
    salesforceLoginUrl: 'https://test.salesforce.com/services/oauth2/authorize?response_type=token&client_id=',
    salesforceClientId: '3MVG9I1kFE5Iul2Cod5500KxYiTOZU.Bd0_xAJwj39F_8fDz0comZ5oEOG673O2MzEm_rgK3NNwBqmy7vNB3R',
    salesforceRedirectUri: 'https://order-go-test.studio55.co.jp/salesforce/callback',
    zoomJSLibUri: 'https://order-go-test.studio55.co.jp/static/websdk/dist/lib',
    firebaseFCMServerKey: 'AAAASCMG1yA:APA91bGQpED-jamCh6E3m1q6xTRRMQCNQ6OahzlVMfGzbQIasDdpKXav8vdGQt6-euuuOwGqzaY_VKmnj8gXfIi1u4bk3E1fg9Hu1LksaKINrkkpzmusrexBAdl9RQCTVLUttUujyB8E',
    goGoMouseKey: '40856363-6e45-4c0c-a09c-d853bbaf4d72',
    pathToAPI: 'https://order-go-test.studio55.co.jp',
    // Don't delete the trailing '/'
    pathToUploads: 'https://order-go-test.studio55.co.jp/',
    mitmUri: 'https://order-go-test.studio55.co.jp/static/mitm.html',
    JapaneseHolidayAPI: 'https://www8.cao.go.jp/chosei/shukujitsu',
    unity3DViewerUrl: 'https://dh92787s85n6l.cloudfront.net/order-go-3d-viewer-build.json',
};

interface LanguageFlag {
    lang: string;
    name: string;
    flag: string;
    active?: boolean;
}


export const textColorOnBackgroundPic = [
    {
        picName:'1.jpg',
        colorCode:'white'
    },
    {
        picName:'2.jpg',
        colorCode:'white'
    },
    {
        picName:'3.jpg',
        colorCode:'white    '
    },
    {
        picName:'4.jpg',
        colorCode:'#434349'
    },
    {
        picName:'5.jpg',
        colorCode:'#434349'
    },
    {
        picName:'6.jpg',
        colorCode:'#434349'
    },
]

export const languages: LanguageFlag[] = [
    {
        lang: 'en',
        name: 'English',
        flag: './assets/media/flags/012-uk.svg'
    },
    {
        lang: 'zh',
        name: '中国',
        flag: './assets/media/flags/015-china.svg'
    },
    {
        lang: 'ja',
        name: '日本語',
        flag: './assets/media/flags/014-japan.svg'
    },
    {
        lang: 'my',
        name: 'မြန်မာ',
        flag: './assets/media/flags/021-myanmar.svg'
    },
    {
        lang: 'vi',
        name: 'Tiếng việt nam',
        flag: './assets/media/flags/022-vietnam.svg'
    },
    {
        lang: 'es',
        name: 'Espanol',
        flag: './assets/media/flags/016-spain.svg'
    }
];

export const timeZones = [
    {group: 'UTC+14:00', value: 'Pacific/Kiritimati', label: 'Pacific/Kiritimati (+14)'},
    {group: 'UTC+13:00', value: 'Pacific/Apia', label: 'Pacific/Apia (+13)'},
    {group: 'UTC+13:00', value: 'Pacific/Enderbury', label: 'Pacific/Enderbury (+13)'},
    {group: 'UTC+13:00', value: 'Pacific/Fakaofo', label: 'Pacific/Fakaofo (+13)'},
    {group: 'UTC+13:00', value: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu (+13)'},
    {group: 'UTC+12:45', value: 'Pacific/Chatham', label: 'Pacific/Chatham (+12:45)'},
    {group: 'UTC+12:00', value: 'Antarctica/McMurdo', label: 'Antarctica/McMurdo (NZST)'},
    {group: 'UTC+12:00', value: 'Asia/Anadyr', label: 'Asia/Anadyr (+12)'},
    {group: 'UTC+12:00', value: 'Asia/Kamchatka', label: 'Asia/Kamchatka (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Auckland', label: 'Pacific/Auckland (NZST)'},
    {group: 'UTC+12:00', value: 'Pacific/Fiji', label: 'Pacific/Fiji (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Funafuti', label: 'Pacific/Funafuti (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Kwajalein', label: 'Pacific/Kwajalein (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Majuro', label: 'Pacific/Majuro (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Nauru', label: 'Pacific/Nauru (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Tarawa', label: 'Pacific/Tarawa (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Wake', label: 'Pacific/Wake (+12)'},
    {group: 'UTC+12:00', value: 'Pacific/Wallis', label: 'Pacific/Wallis (+12)'},
    {group: 'UTC+11:00', value: 'Antarctica/Casey', label: 'Antarctica/Casey (+11)'},
    {group: 'UTC+11:00', value: 'Antarctica/Macquarie', label: 'Antarctica/Macquarie (+11)'},
    {group: 'UTC+11:00', value: 'Asia/Magadan', label: 'Asia/Magadan (+11)'},
    {group: 'UTC+11:00', value: 'Asia/Sakhalin', label: 'Asia/Sakhalin (+11)'},
    {group: 'UTC+11:00', value: 'Asia/Srednekolymsk', label: 'Asia/Srednekolymsk (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Bougainville', label: 'Pacific/Bougainville (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Efate', label: 'Pacific/Efate (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Guadalcanal', label: 'Pacific/Guadalcanal (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Kosrae', label: 'Pacific/Kosrae (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Norfolk', label: 'Pacific/Norfolk (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Noumea', label: 'Pacific/Noumea (+11)'},
    {group: 'UTC+11:00', value: 'Pacific/Pohnpei', label: 'Pacific/Pohnpei (+11)'},
    {group: 'UTC+10:30', value: 'Australia/Lord_Howe', label: 'Australia/Lord Howe (+10:30)'},
    {group: 'UTC+10:00', value: 'Antarctica/DumontDUrville', label: 'Antarctica/DumontDUrville (+10)'},
    {group: 'UTC+10:00', value: 'Asia/Ust-Nera', label: 'Asia/Ust-Nera (+10)'},
    {group: 'UTC+10:00', value: 'Asia/Vladivostok', label: 'Asia/Vladivostok (+10)'},
    {group: 'UTC+10:00', value: 'Australia/Brisbane', label: 'Australia/Brisbane (AEST)'},
    {group: 'UTC+10:00', value: 'Australia/Currie', label: 'Australia/Currie (AEST)'},
    {group: 'UTC+10:00', value: 'Australia/Hobart', label: 'Australia/Hobart (AEST)'},
    {group: 'UTC+10:00', value: 'Australia/Lindeman', label: 'Australia/Lindeman (AEST)'},
    {group: 'UTC+10:00', value: 'Australia/Melbourne', label: 'Australia/Melbourne (AEST)'},
    {group: 'UTC+10:00', value: 'Australia/Sydney', label: 'Australia/Sydney (AEST)'},
    {group: 'UTC+10:00', value: 'Pacific/Chuuk', label: 'Pacific/Chuuk (+10)'},
    {group: 'UTC+10:00', value: 'Pacific/Guam', label: 'Pacific/Guam (ChST)'},
    {group: 'UTC+10:00', value: 'Pacific/Port_Moresby', label: 'Pacific/Port Moresby (+10)'},
    {group: 'UTC+10:00', value: 'Pacific/Saipan', label: 'Pacific/Saipan (ChST)'},
    {group: 'UTC+09:30', value: 'Australia/Adelaide', label: 'Australia/Adelaide (ACST)'},
    {group: 'UTC+09:30', value: 'Australia/Broken_Hill', label: 'Australia/Broken Hill (ACST)'},
    {group: 'UTC+09:30', value: 'Australia/Darwin', label: 'Australia/Darwin (ACST)'},
    {group: 'UTC+09:00', value: 'Asia/Chita', label: 'Asia/Chita (+09)'},
    {group: 'UTC+09:00', value: 'Asia/Dili', label: 'Asia/Dili (+09)'},
    {group: 'UTC+09:00', value: 'Asia/Jayapura', label: 'Asia/Jayapura (WIT)'},
    {group: 'UTC+09:00', value: 'Asia/Khandyga', label: 'Asia/Khandyga (+09)'},
    {group: 'UTC+09:00', value: 'Asia/Seoul', label: 'Asia/Seoul (KST)'},
    {group: 'UTC+09:00', value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)'},
    {group: 'UTC+09:00', value: 'Asia/Yakutsk', label: 'Asia/Yakutsk (+09)'},
    {group: 'UTC+09:00', value: 'Pacific/Palau', label: 'Pacific/Palau (+09)'},
    {group: 'UTC+08:45', value: 'Australia/Eucla', label: 'Australia/Eucla (+08:45)'},
    {group: 'UTC+08:30', value: 'Asia/Pyongyang', label: 'Asia/Pyongyang (KST)'},
    {group: 'UTC+08:00', value: 'Asia/Brunei', label: 'Asia/Brunei (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Choibalsan', label: 'Asia/Choibalsan (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Hong_Kong', label: 'Asia/Hong Kong (HKT)'},
    {group: 'UTC+08:00', value: 'Asia/Irkutsk', label: 'Asia/Irkutsk (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Kuala_Lumpur', label: 'Asia/Kuala Lumpur (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Kuching', label: 'Asia/Kuching (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Macau', label: 'Asia/Macau (CST)'},
    {group: 'UTC+08:00', value: 'Asia/Makassar', label: 'Asia/Makassar (WITA)'},
    {group: 'UTC+08:00', value: 'Asia/Manila', label: 'Asia/Manila (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Shanghai', label: 'Asia/Shanghai (CST)'},
    {group: 'UTC+08:00', value: 'Asia/Singapore', label: 'Asia/Singapore (+08)'},
    {group: 'UTC+08:00', value: 'Asia/Taipei', label: 'Asia/Taipei (CST)'},
    {group: 'UTC+08:00', value: 'Asia/Ulaanbaatar', label: 'Asia/Ulaanbaatar (+08)'},
    {group: 'UTC+08:00', value: 'Australia/Perth', label: 'Australia/Perth (AWST)'},
    {group: 'UTC+07:00', value: 'Antarctica/Davis', label: 'Antarctica/Davis (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Bangkok', label: 'Asia/Bangkok (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Barnaul', label: 'Asia/Barnaul (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Ho_Chi_Minh', label: 'Asia/Ho Chi Minh (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Hovd', label: 'Asia/Hovd (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Jakarta', label: 'Asia/Jakarta (WIB)'},
    {group: 'UTC+07:00', value: 'Asia/Krasnoyarsk', label: 'Asia/Krasnoyarsk (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Novokuznetsk', label: 'Asia/Novokuznetsk (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Novosibirsk', label: 'Asia/Novosibirsk (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Phnom_Penh', label: 'Asia/Phnom_Penh (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Pontianak', label: 'Asia/Pontianak (WIB)'},
    {group: 'UTC+07:00', value: 'Asia/Tomsk', label: 'Asia/Tomsk (+07)'},
    {group: 'UTC+07:00', value: 'Asia/Vientiane', label: 'Asia/Vientiane (+07)'},
    {group: 'UTC+07:00', value: 'Indian/Christmas', label: 'Indian/Christmas (+07)'},
    {group: 'UTC+06:30', value: 'Asia/Yangon', label: 'Asia/Yangon (+06:30)'},
    {group: 'UTC+06:30', value: 'Indian/Cocos', label: 'Indian/Cocos (+06:30)'},
    {group: 'UTC+06:00', value: 'Antarctica/Vostok', label: 'Antarctica/Vostok (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Almaty', label: 'Asia/Almaty (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Bishkek', label: 'Asia/Bishkek (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Dhaka', label: 'Asia/Dhaka (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Omsk', label: 'Asia/Omsk (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Qyzylorda', label: 'Asia/Qyzylorda (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Thimphu', label: 'Asia/Thimphu (+06)'},
    {group: 'UTC+06:00', value: 'Asia/Urumqi', label: 'Asia/Urumqi (+06)'},
    {group: 'UTC+06:00', value: 'Indian/Chagos', label: 'Indian/Chagos (+06)'},
    {group: 'UTC+05:45', value: 'Asia/Kathmandu', label: 'Asia/Kathmandu (+05:45)'},
    {group: 'UTC+05:30', value: 'Asia/Colombo', label: 'Asia/Colombo (+05:30)'},
    {group: 'UTC+05:30', value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)'},
    {group: 'UTC+05:00', value: 'Antarctica/Mawson', label: 'Antarctica/Mawson (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Aqtau', label: 'Asia/Aqtau (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Aqtobe', label: 'Asia/Aqtobe (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Ashgabat', label: 'Asia/Ashgabat (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Atyrau', label: 'Asia/Atyrau (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Dushanbe', label: 'Asia/Dushanbe (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Karachi', label: 'Asia/Karachi (PKT)'},
    {group: 'UTC+05:00', value: 'Asia/Oral', label: 'Asia/Oral (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Samarkand', label: 'Asia/Samarkand (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Tashkent', label: 'Asia/Tashkent (+05)'},
    {group: 'UTC+05:00', value: 'Asia/Yekaterinburg', label: 'Asia/Yekaterinburg (+05)'},
    {group: 'UTC+05:00', value: 'Indian/Kerguelen', label: 'Indian/Kerguelen (+05)'},
    {group: 'UTC+05:00', value: 'Indian/Maldives', label: 'Indian/Maldives (+05)'},
    {group: 'UTC+04:30', value: 'Asia/Kabul', label: 'Asia/Kabul (+04:30)'},
    {group: 'UTC+04:30', value: 'Asia/Tehran', label: 'Asia/Tehran (+04:30)'},
    {group: 'UTC+04:00', value: 'Asia/Baku', label: 'Asia/Baku (+04)'},
    {group: 'UTC+04:00', value: 'Asia/Dubai', label: 'Asia/Dubai (+04)'},
    {group: 'UTC+04:00', value: 'Asia/Muscat', label: 'Asia/Muscat (+04)'},
    {group: 'UTC+04:00', value: 'Asia/Tbilisi', label: 'Asia/Tbilisi (+04)'},
    {group: 'UTC+04:00', value: 'Asia/Yerevan', label: 'Asia/Yerevan (+04)'},
    {group: 'UTC+04:00', value: 'Europe/Astrakhan', label: 'Europe/Astrakhan (+04)'},
    {group: 'UTC+04:00', value: 'Europe/Samara', label: 'Europe/Samara (+04)'},
    {group: 'UTC+04:00', value: 'Europe/Saratov', label: 'Europe/Saratov (+04)'},
    {group: 'UTC+04:00', value: 'Europe/Ulyanovsk', label: 'Europe/Ulyanovsk (+04)'},
    {group: 'UTC+04:00', value: 'Indian/Mahe', label: 'Indian/Mahe (+04)'},
    {group: 'UTC+04:00', value: 'Indian/Mauritius', label: 'Indian/Mauritius (+04)'},
    {group: 'UTC+04:00', value: 'Indian/Reunion', label: 'Indian/Reunion (+04)'},
    {group: 'UTC+03:00', value: 'Africa/Addis_Ababa', label: 'Africa/Addis Ababa (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Asmara', label: 'Africa/Asmara (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Dar_es_Salaam', label: 'Africa/Dar es Salaam (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Djibouti', label: 'Africa/Djibouti (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Juba', label: 'Africa/Juba (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Kampala', label: 'Africa/Kampala (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Khartoum', label: 'Africa/Khartoum (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Mogadishu', label: 'Africa/Mogadishu (EAT)'},
    {group: 'UTC+03:00', value: 'Africa/Nairobi', label: 'Africa/Nairobi (EAT)'},
    {group: 'UTC+03:00', value: 'Antarctica/Syowa', label: 'Antarctica/Syowa (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Aden', label: 'Asia/Aden (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Amman', label: 'Asia/Amman (EEST)'},
    {group: 'UTC+03:00', value: 'Asia/Baghdad', label: 'Asia/Baghdad (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Bahrain', label: 'Asia/Bahrain (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Beirut', label: 'Asia/Beirut (EEST)'},
    {group: 'UTC+03:00', value: 'Asia/Damascus', label: 'Asia/Damascus (EEST)'},
    {group: 'UTC+03:00', value: 'Asia/Famagusta', label: 'Asia/Famagusta (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Gaza', label: 'Asia/Gaza (EEST)'},
    {group: 'UTC+03:00', value: 'Asia/Hebron', label: 'Asia/Hebron (EEST)'},
    {group: 'UTC+03:00', value: 'Asia/Jerusalem', label: 'Asia/Jerusalem (IDT)'},
    {group: 'UTC+03:00', value: 'Asia/Kuwait', label: 'Asia/Kuwait (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Nicosia', label: 'Asia/Nicosia (EEST)'},
    {group: 'UTC+03:00', value: 'Asia/Qatar', label: 'Asia/Qatar (+03)'},
    {group: 'UTC+03:00', value: 'Asia/Riyadh', label: 'Asia/Riyadh (+03)'},
    {group: 'UTC+03:00', value: 'Europe/Athens', label: 'Europe/Athens (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Bucharest', label: 'Europe/Bucharest (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Chisinau', label: 'Europe/Chisinau (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Helsinki', label: 'Europe/Helsinki (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Istanbul', label: 'Europe/Istanbul (+03)'},
    {group: 'UTC+03:00', value: 'Europe/Kiev', label: 'Europe/Kiev (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Kirov', label: 'Europe/Kirov (+03)'},
    {group: 'UTC+03:00', value: 'Europe/Mariehamn', label: 'Europe/Mariehamn (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Minsk', label: 'Europe/Minsk (+03)'},
    {group: 'UTC+03:00', value: 'Europe/Moscow', label: 'Europe/Moscow (MSK)'},
    {group: 'UTC+03:00', value: 'Europe/Riga', label: 'Europe/Riga (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Simferopol', label: 'Europe/Simferopol (MSK)'},
    {group: 'UTC+03:00', value: 'Europe/Sofia', label: 'Europe/Sofia (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Tallinn', label: 'Europe/Tallinn (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Uzhgorod', label: 'Europe/Uzhgorod (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Vilnius', label: 'Europe/Vilnius (EEST)'},
    {group: 'UTC+03:00', value: 'Europe/Volgograd', label: 'Europe/Volgograd (+03)'},
    {group: 'UTC+03:00', value: 'Europe/Zaporozhye', label: 'Europe/Zaporozhye (EEST)'},
    {group: 'UTC+03:00', value: 'Indian/Antananarivo', label: 'Indian/Antananarivo (EAT)'},
    {group: 'UTC+03:00', value: 'Indian/Comoro', label: 'Indian/Comoro (EAT)'},
    {group: 'UTC+03:00', value: 'Indian/Mayotte', label: 'Indian/Mayotte (EAT)'},
    {group: 'UTC+02:00', value: 'Africa/Blantyre', label: 'Africa/Blantyre (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Bujumbura', label: 'Africa/Bujumbura (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Cairo', label: 'Africa/Cairo (EET)'},
    {group: 'UTC+02:00', value: 'Africa/Ceuta', label: 'Africa/Ceuta (CEST)'},
    {group: 'UTC+02:00', value: 'Africa/Gaborone', label: 'Africa/Gaborone (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Harare', label: 'Africa/Harare (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Johannesburg', label: 'Africa/Johannesburg (SAST)'},
    {group: 'UTC+02:00', value: 'Africa/Kigali', label: 'Africa/Kigali (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Lusaka', label: 'Africa/Lusaka (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Maputo', label: 'Africa/Maputo (CAT)'},
    {group: 'UTC+02:00', value: 'Africa/Maseru', label: 'Africa/Maseru (SAST)'},
    {group: 'UTC+02:00', value: 'Africa/Mbabane', label: 'Africa/Mbabane (SAST)'},
    {group: 'UTC+02:00', value: 'Africa/Tripoli', label: 'Africa/Tripoli (EET)'},
    {group: 'UTC+02:00', value: 'Antarctica/Troll', label: 'Antarctica/Troll (+02)'},
    {group: 'UTC+02:00', value: 'Arctic/Longyearbyen', label: 'Arctic/Longyearbyen (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Amsterdam', label: 'Europe/Amsterdam (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Andorra', label: 'Europe/Andorra (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Belgrade', label: 'Europe/Belgrade (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Berlin', label: 'Europe/Berlin (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Bratislava', label: 'Europe/Bratislava (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Brussels', label: 'Europe/Brussels (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Budapest', label: 'Europe/Budapest (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Busingen', label: 'Europe/Busingen (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Copenhagen', label: 'Europe/Copenhagen (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Gibraltar', label: 'Europe/Gibraltar (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Kaliningrad', label: 'Europe/Kaliningrad (EET)'},
    {group: 'UTC+02:00', value: 'Europe/Ljubljana', label: 'Europe/Ljubljana (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Luxembourg', label: 'Europe/Luxembourg (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Madrid', label: 'Europe/Madrid (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Malta', label: 'Europe/Malta (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Monaco', label: 'Europe/Monaco (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Oslo', label: 'Europe/Oslo (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Paris', label: 'Europe/Paris (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Podgorica', label: 'Europe/Podgorica (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Prague', label: 'Europe/Prague (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Rome', label: 'Europe/Rome (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/San_Marino', label: 'Europe/San Marino (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Sarajevo', label: 'Europe/Sarajevo (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Skopje', label: 'Europe/Skopje (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Stockholm', label: 'Europe/Stockholm (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Tirane', label: 'Europe/Tirane (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Vaduz', label: 'Europe/Vaduz (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Vatican', label: 'Europe/Vatican (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Vienna', label: 'Europe/Vienna (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Warsaw', label: 'Europe/Warsaw (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Zagreb', label: 'Europe/Zagreb (CEST)'},
    {group: 'UTC+02:00', value: 'Europe/Zurich', label: 'Europe/Zurich (CEST)'},
    {group: 'UTC+01:00', value: 'Africa/Algiers', label: 'Africa/Algiers (CET)'},
    {group: 'UTC+01:00', value: 'Africa/Bangui', label: 'Africa/Bangui (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Brazzaville', label: 'Africa/Brazzaville (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Casablanca', label: 'Africa/Casablanca (WEST)'},
    {group: 'UTC+01:00', value: 'Africa/Douala', label: 'Africa/Douala (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/El_Aaiun', label: 'Africa/El Aaiun (WEST)'},
    {group: 'UTC+01:00', value: 'Africa/Kinshasa', label: 'Africa/Kinshasa (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Lagos', label: 'Africa/Lagos (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Libreville', label: 'Africa/Libreville (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Luanda', label: 'Africa/Luanda (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Malabo', label: 'Africa/Malabo (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Ndjamena', label: 'Africa/Ndjamena (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Niamey', label: 'Africa/Niamey (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Porto-Novo', label: 'Africa/Porto-Novo (WAT)'},
    {group: 'UTC+01:00', value: 'Africa/Tunis', label: 'Africa/Tunis (CET)'},
    {group: 'UTC+01:00', value: 'Africa/Windhoek', label: 'Africa/Windhoek (WAT)'},
    {group: 'UTC+01:00', value: 'Atlantic/Canary', label: 'Atlantic/Canary (WEST)'},
    {group: 'UTC+01:00', value: 'Atlantic/Faroe', label: 'Atlantic/Faroe (WEST)'},
    {group: 'UTC+01:00', value: 'Atlantic/Madeira', label: 'Atlantic/Madeira (WEST)'},
    {group: 'UTC+01:00', value: 'Europe/Dublin', label: 'Europe/Dublin (IST)'},
    {group: 'UTC+01:00', value: 'Europe/Guernsey', label: 'Europe/Guernsey (BST)'},
    {group: 'UTC+01:00', value: 'Europe/Isle_of_Man', label: 'Europe/Isle of Man (BST)'},
    {group: 'UTC+01:00', value: 'Europe/Jersey', label: 'Europe/Jersey (BST)'},
    {group: 'UTC+01:00', value: 'Europe/Lisbon', label: 'Europe/Lisbon (WEST)'},
    {group: 'UTC+01:00', value: 'Europe/London', label: 'Europe/London (BST)'},
    {group: 'UTC', value: 'Africa/Abidjan', label: 'Africa/Abidjan (GMT)'},
    {group: 'UTC', value: 'Africa/Accra', label: 'Africa/Accra (GMT)'},
    {group: 'UTC', value: 'Africa/Bamako', label: 'Africa/Bamako (GMT)'},
    {group: 'UTC', value: 'Africa/Banjul', label: 'Africa/Banjul (GMT)'},
    {group: 'UTC', value: 'Africa/Bissau', label: 'Africa/Bissau (GMT)'},
    {group: 'UTC', value: 'Africa/Conakry', label: 'Africa/Conakry (GMT)'},
    {group: 'UTC', value: 'Africa/Dakar', label: 'Africa/Dakar (GMT)'},
    {group: 'UTC', value: 'Africa/Freetown', label: 'Africa/Freetown (GMT)'},
    {group: 'UTC', value: 'Africa/Lome', label: 'Africa/Lome (GMT)'},
    {group: 'UTC', value: 'Africa/Monrovia', label: 'Africa/Monrovia (GMT)'},
    {group: 'UTC', value: 'Africa/Nouakchott', label: 'Africa/Nouakchott (GMT)'},
    {group: 'UTC', value: 'Africa/Ouagadougou', label: 'Africa/Ouagadougou (GMT)'},
    {group: 'UTC', value: 'Africa/Sao_Tome', label: 'Africa/Sao_Tome (GMT)'},
    {group: 'UTC', value: 'America/Danmarkshavn', label: 'America/Danmarkshavn (GMT)'},
    {group: 'UTC', value: 'America/Scoresbysund', label: 'America/Scoresbysund (+00)'},
    {group: 'UTC', value: 'Atlantic/Azores', label: 'Atlantic/Azores (+00)'},
    {group: 'UTC', value: 'Atlantic/Reykjavik', label: 'Atlantic/Reykjavik (GMT)'},
    {group: 'UTC', value: 'Atlantic/St_Helena', label: 'Atlantic/St_Helena (GMT)'},
    {group: 'UTC', value: 'UTC', label: 'UTC (UTC)'},
    {group: 'UTC-01:00', value: 'Atlantic/Cape_Verde', label: 'Atlantic/Cape Verde (-01)'},
    {group: 'UTC-02:00', value: 'America/Godthab', label: 'America/Godthab (-02)'},
    {group: 'UTC-02:00', value: 'America/Miquelon', label: 'America/Miquelon (-02)'},
    {group: 'UTC-02:00', value: 'America/Noronha', label: 'America/Noronha (-02)'},
    {group: 'UTC-02:00', value: 'Atlantic/South_Georgia', label: 'Atlantic/South Georgia (-02)'},
    {group: 'UTC-02:30', value: 'America/St_Johns', label: 'America/St Johns (NDT)'},
    {group: 'UTC-03:00', value: 'America/Araguaina', label: 'America/Araguaina (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Buenos_Aires', label: 'America/Argentina/Buenos Aires (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Catamarca', label: 'America/Argentina/Catamarca (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Cordoba', label: 'America/Argentina/Cordoba (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Jujuy', label: 'America/Argentina/Jujuy (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/La_Rioja', label: 'America/Argentina/La Rioja (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Mendoza', label: 'America/Argentina/Mendoza (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Rio_Gallegos', label: 'America/Argentina/Rio Gallegos (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Salta', label: 'America/Argentina/Salta (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/San_Juan', label: 'America/Argentina/San Juan (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/San_Luis', label: 'America/Argentina/San Luis (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Tucuman', label: 'America/Argentina/Tucuman (-03)'},
    {group: 'UTC-03:00', value: 'America/Argentina/Ushuaia', label: 'America/Argentina/Ushuaia (-03)'},
    {group: 'UTC-03:00', value: 'America/Bahia', label: 'America/Bahia (-03)'},
    {group: 'UTC-03:00', value: 'America/Belem', label: 'America/Belem (-03)'},
    {group: 'UTC-03:00', value: 'America/Cayenne', label: 'America/Cayenne (-03)'},
    {group: 'UTC-03:00', value: 'America/Fortaleza', label: 'America/Fortaleza (-03)'},
    {group: 'UTC-03:00', value: 'America/Glace_Bay', label: 'America/Glace_Bay (ADT)'},
    {group: 'UTC-03:00', value: 'America/Goose_Bay', label: 'America/Goose_Bay (ADT)'},
    {group: 'UTC-03:00', value: 'America/Halifax', label: 'America/Halifax (ADT)'},
    {group: 'UTC-03:00', value: 'America/Maceio', label: 'America/Maceio (-03)'},
    {group: 'UTC-03:00', value: 'America/Moncton', label: 'America/Moncton (ADT)'},
    {group: 'UTC-03:00', value: 'America/Montevideo', label: 'America/Montevideo (-03)'},
    {group: 'UTC-03:00', value: 'America/Paramaribo', label: 'America/Paramaribo (-03)'},
    {group: 'UTC-03:00', value: 'America/Punta_Arenas', label: 'America/Punta Arenas (-03)'},
    {group: 'UTC-03:00', value: 'America/Recife', label: 'America/Recife (-03)'},
    {group: 'UTC-03:00', value: 'America/Santarem', label: 'America/Santarem (-03)'},
    {group: 'UTC-03:00', value: 'America/Sao_Paulo', label: 'America/Sao Paulo (-03)'},
    {group: 'UTC-03:00', value: 'America/Thule', label: 'America/Thule (ADT)'},
    {group: 'UTC-03:00', value: 'Antarctica/Palmer', label: 'Antarctica/Palmer (-03)'},
    {group: 'UTC-03:00', value: 'Antarctica/Rothera', label: 'Antarctica/Rothera (-03)'},
    {group: 'UTC-03:00', value: 'Atlantic/Bermuda', label: 'Atlantic/Bermuda (ADT)'},
    {group: 'UTC-03:00', value: 'Atlantic/Stanley', label: 'Atlantic/Stanley (-03)'},
    {group: 'UTC-04:00', value: 'America/Anguilla', label: 'America/Anguilla (AST)'},
    {group: 'UTC-04:00', value: 'America/Antigua', label: 'America/Antigua (AST)'},
    {group: 'UTC-04:00', value: 'America/Aruba', label: 'America/Aruba (AST)'},
    {group: 'UTC-04:00', value: 'America/Asuncion', label: 'America/Asuncion (-04)'},
    {group: 'UTC-04:00', value: 'America/Barbados', label: 'America/Barbados (AST)'},
    {group: 'UTC-04:00', value: 'America/Blanc-Sablon', label: 'America/Blanc-Sablon (AST)'},
    {group: 'UTC-04:00', value: 'America/Boa_Vista', label: 'America/Boa Vista (-04)'},
    {group: 'UTC-04:00', value: 'America/Campo_Grande', label: 'America/Campo Grande (-04)'},
    {group: 'UTC-04:00', value: 'America/Caracas', label: 'America/Caracas (-04)'},
    {group: 'UTC-04:00', value: 'America/Cuiaba', label: 'America/Cuiaba (-04)'},
    {group: 'UTC-04:00', value: 'America/Curacao', label: 'America/Curacao (AST)'},
    {group: 'UTC-04:00', value: 'America/Detroit', label: 'America/Detroit (EDT)'},
    {group: 'UTC-04:00', value: 'America/Dominica', label: 'America/Dominica (AST)'},
    {group: 'UTC-04:00', value: 'America/Grand_Turk', label: 'America/Grand Turk (AST)'},
    {group: 'UTC-04:00', value: 'America/Grenada', label: 'America/Grenada (AST)'},
    {group: 'UTC-04:00', value: 'America/Guadeloupe', label: 'America/Guadeloupe (AST)'},
    {group: 'UTC-04:00', value: 'America/Guyana', label: 'America/Guyana (-04)'},
    {group: 'UTC-04:00', value: 'America/Havana', label: 'America/Havana (CDT)'},
    {group: 'UTC-04:00', value: 'America/Indiana/Indianapolis', label: 'America/Indiana/Indianapolis (EDT)'},
    {group: 'UTC-04:00', value: 'America/Indiana/Marengo', label: 'America/Indiana/Marengo (EDT)'},
    {group: 'UTC-04:00', value: 'America/Indiana/Petersburg', label: 'America/Indiana/Petersburg (EDT)'},
    {group: 'UTC-04:00', value: 'America/Indiana/Vevay', label: 'America/Indiana/Vevay (EDT)'},
    {group: 'UTC-04:00', value: 'America/Indiana/Vincennes', label: 'America/Indiana/Vincennes (EDT)'},
    {group: 'UTC-04:00', value: 'America/Indiana/Winamac', label: 'America/Indiana/Winamac (EDT)'},
    {group: 'UTC-04:00', value: 'America/Iqaluit', label: 'America/Iqaluit (EDT)'},
    {group: 'UTC-04:00', value: 'America/Kentucky/Louisville', label: 'America/Kentucky/Louisville (EDT)'},
    {group: 'UTC-04:00', value: 'America/Kentucky/Monticello', label: 'America/Kentucky/Monticello (EDT)'},
    {group: 'UTC-04:00', value: 'America/Kralendijk', label: 'America/Kralendijk (AST)'},
    {group: 'UTC-04:00', value: 'America/La_Paz', label: 'America/La_Paz (-04)'},
    {group: 'UTC-04:00', value: 'America/Lower_Princes', label: 'America/Lower Princes (AST)'},
    {group: 'UTC-04:00', value: 'America/Manaus', label: 'America/Manaus (-04)'},
    {group: 'UTC-04:00', value: 'America/Marigot', label: 'America/Marigot (AST)'},
    {group: 'UTC-04:00', value: 'America/Martinique', label: 'America/Martinique (AST)'},
    {group: 'UTC-04:00', value: 'America/Montserrat', label: 'America/Montserrat (AST)'},
    {group: 'UTC-04:00', value: 'America/Nassau', label: 'America/Nassau (EDT)'},
    {group: 'UTC-04:00', value: 'America/New_York', label: 'America/New_York (EDT)'},
    {group: 'UTC-04:00', value: 'America/Nipigon', label: 'America/Nipigon (EDT)'},
    {group: 'UTC-04:00', value: 'America/Pangnirtung', label: 'America/Pangnirtung (EDT)'},
    {group: 'UTC-04:00', value: 'America/Port-au-Prince', label: 'America/Port-au-Prince (EDT)'},
    {group: 'UTC-04:00', value: 'America/Port_of_Spain', label: 'America/Port of Spain (AST)'},
    {group: 'UTC-04:00', value: 'America/Porto_Velho', label: 'America/Porto Velho (-04)'},
    {group: 'UTC-04:00', value: 'America/Puerto_Rico', label: 'America/Puerto Rico (AST)'},
    {group: 'UTC-04:00', value: 'America/Santiago', label: 'America/Santiago (-04)'},
    {group: 'UTC-04:00', value: 'America/Santo_Domingo', label: 'America/Santo Domingo (AST)'},
    {group: 'UTC-04:00', value: 'America/St_Barthelemy', label: 'America/St Barthelemy (AST)'},
    {group: 'UTC-04:00', value: 'America/St_Kitts', label: 'America/St Kitts (AST)'},
    {group: 'UTC-04:00', value: 'America/St_Lucia', label: 'America/St Lucia (AST)'},
    {group: 'UTC-04:00', value: 'America/St_Thomas', label: 'America/St Thomas (AST)'},
    {group: 'UTC-04:00', value: 'America/St_Vincent', label: 'America/St Vincent (AST)'},
    {group: 'UTC-04:00', value: 'America/Thunder_Bay', label: 'America/Thunder Bay (EDT)'},
    {group: 'UTC-04:00', value: 'America/Toronto', label: 'America/Toronto (EDT)'},
    {group: 'UTC-04:00', value: 'America/Tortola', label: 'America/Tortola (AST)'},
    {group: 'UTC-05:00', value: 'America/Atikokan', label: 'America/Atikokan (EST)'},
    {group: 'UTC-05:00', value: 'America/Bahia_Banderas', label: 'America/Bahia Banderas (CDT)'},
    {group: 'UTC-05:00', value: 'America/Bogota', label: 'America/Bogota (-05)'},
    {group: 'UTC-05:00', value: 'America/Cancun', label: 'America/Cancun (EST)'},
    {group: 'UTC-05:00', value: 'America/Cayman', label: 'America/Cayman (EST)'},
    {group: 'UTC-05:00', value: 'America/Chicago', label: 'America/Chicago (CDT)'},
    {group: 'UTC-05:00', value: 'America/Eirunepe', label: 'America/Eirunepe (-05)'},
    {group: 'UTC-05:00', value: 'America/Guayaquil', label: 'America/Guayaquil (-05)'},
    {group: 'UTC-05:00', value: 'America/Indiana/Knox', label: 'America/Indiana/Knox (CDT)'},
    {group: 'UTC-05:00', value: 'America/Indiana/Tell_City', label: 'America/Indiana/Tell City (CDT)'},
    {group: 'UTC-05:00', value: 'America/Jamaica', label: 'America/Jamaica (EST)'},
    {group: 'UTC-05:00', value: 'America/Lima', label: 'America/Lima (-05)'},
    {group: 'UTC-05:00', value: 'America/Matamoros', label: 'America/Matamoros (CDT)'},
    {group: 'UTC-05:00', value: 'America/Menominee', label: 'America/Menominee (CDT)'},
    {group: 'UTC-05:00', value: 'America/Merida', label: 'America/Merida (CDT)'},
    {group: 'UTC-05:00', value: 'America/Mexico_City', label: 'America/Mexico City (CDT)'},
    {group: 'UTC-05:00', value: 'America/Monterrey', label: 'America/Monterrey (CDT)'},
    {group: 'UTC-05:00', value: 'America/North_Dakota/Beulah', label: 'America/North Dakota/Beulah (CDT)'},
    {group: 'UTC-05:00', value: 'America/North_Dakota/Center', label: 'America/North Dakota/Center (CDT)'},
    {group: 'UTC-05:00', value: 'America/North_Dakota/New_Salem', label: 'America/North Dakota/New Salem (CDT)'},
    {group: 'UTC-05:00', value: 'America/Panama', label: 'America/Panama (EST)'},
    {group: 'UTC-05:00', value: 'America/Rainy_River', label: 'America/Rainy River (CDT)'},
    {group: 'UTC-05:00', value: 'America/Rankin_Inlet', label: 'America/Rankin Inlet (CDT)'},
    {group: 'UTC-05:00', value: 'America/Resolute', label: 'America/Resolute (CDT)'},
    {group: 'UTC-05:00', value: 'America/Rio_Branco', label: 'America/Rio Branco (-05)'},
    {group: 'UTC-05:00', value: 'America/Winnipeg', label: 'America/Winnipeg (CDT)'},
    {group: 'UTC-06:00', value: 'America/Belize', label: 'America/Belize (CST)'},
    {group: 'UTC-06:00', value: 'America/Boise', label: 'America/Boise (MDT)'},
    {group: 'UTC-06:00', value: 'America/Cambridge_Bay', label: 'America/Cambridge Bay (MDT)'},
    {group: 'UTC-06:00', value: 'America/Chihuahua', label: 'America/Chihuahua (MDT)'},
    {group: 'UTC-06:00', value: 'America/Costa_Rica', label: 'America/Costa Rica (CST)'},
    {group: 'UTC-06:00', value: 'America/Denver', label: 'America/Denver (MDT)'},
    {group: 'UTC-06:00', value: 'America/Edmonton', label: 'America/Edmonton (MDT)'},
    {group: 'UTC-06:00', value: 'America/El_Salvador', label: 'America/El Salvador (CST)'},
    {group: 'UTC-06:00', value: 'America/Guatemala', label: 'America/Guatemala (CST)'},
    {group: 'UTC-06:00', value: 'America/Inuvik', label: 'America/Inuvik (MDT)'},
    {group: 'UTC-06:00', value: 'America/Managua', label: 'America/Managua (CST)'},
    {group: 'UTC-06:00', value: 'America/Mazatlan', label: 'America/Mazatlan (MDT)'},
    {group: 'UTC-06:00', value: 'America/Ojinaga', label: 'America/Ojinaga (MDT)'},
    {group: 'UTC-06:00', value: 'America/Regina', label: 'America/Regina (CST)'},
    {group: 'UTC-06:00', value: 'America/Swift_Current', label: 'America/Swift Current (CST)'},
    {group: 'UTC-06:00', value: 'America/Tegucigalpa', label: 'America/Tegucigalpa (CST)'},
    {group: 'UTC-06:00', value: 'America/Yellowknife', label: 'America/Yellowknife (MDT)'},
    {group: 'UTC-06:00', value: 'Pacific/Easter', label: 'Pacific/Easter (-06)'},
    {group: 'UTC-06:00', value: 'Pacific/Galapagos', label: 'Pacific/Galapagos (-06)'},
    {group: 'UTC-07:00', value: 'America/Creston', label: 'America/Creston (MST)'},
    {group: 'UTC-07:00', value: 'America/Dawson', label: 'America/Dawson (PDT)'},
    {group: 'UTC-07:00', value: 'America/Dawson_Creek', label: 'America/Dawson Creek (MST)'},
    {group: 'UTC-07:00', value: 'America/Fort_Nelson', label: 'America/Fort Nelson (MST)'},
    {group: 'UTC-07:00', value: 'America/Hermosillo', label: 'America/Hermosillo (MST)'},
    {group: 'UTC-07:00', value: 'America/Los_Angeles', label: 'America/Los Angeles (PDT)'},
    {group: 'UTC-07:00', value: 'America/Phoenix', label: 'America/Phoenix (MST)'},
    {group: 'UTC-07:00', value: 'America/Tijuana', label: 'America/Tijuana (PDT)'},
    {group: 'UTC-07:00', value: 'America/Vancouver', label: 'America/Vancouver (PDT)'},
    {group: 'UTC-07:00', value: 'America/Whitehorse', label: 'America/Whitehorse (PDT)'},
    {group: 'UTC-08:00', value: 'America/Anchorage', label: 'America/Anchorage (AKDT)'},
    {group: 'UTC-08:00', value: 'America/Juneau', label: 'America/Juneau (AKDT)'},
    {group: 'UTC-08:00', value: 'America/Metlakatla', label: 'America/Metlakatla (AKDT)'},
    {group: 'UTC-08:00', value: 'America/Nome', label: 'America/Nome (AKDT)'},
    {group: 'UTC-08:00', value: 'America/Sitka', label: 'America/Sitka (AKDT)'},
    {group: 'UTC-08:00', value: 'America/Yakutat', label: 'America/Yakutat (AKDT)'},
    {group: 'UTC-08:00', value: 'Pacific/Pitcairn', label: 'Pacific/Pitcairn (-08)'},
    {group: 'UTC-09:00', value: 'America/Adak', label: 'America/Adak (HDT)'},
    {group: 'UTC-09:00', value: 'Pacific/Gambier', label: 'Pacific/Gambier (-09)'},
    {group: 'UTC-09:30', value: 'Pacific/Marquesas', label: 'Pacific/Marquesas (-09:30)'},
    {group: 'UTC-10:00', value: 'Pacific/Honolulu', label: 'Pacific/Honolulu (HST)'},
    {group: 'UTC-10:00', value: 'Pacific/Rarotonga', label: 'Pacific/Rarotonga (-10)'},
    {group: 'UTC-10:00', value: 'Pacific/Tahiti', label: 'Pacific/Tahiti (-10)'},
    {group: 'UTC-11:00', value: 'Pacific/Midway', label: 'Pacific/Midway (SST)'},
    {group: 'UTC-11:00', value: 'Pacific/Niue', label: 'Pacific/Niue (-11)'},
    {group: 'UTC-11:00', value: 'Pacific/Pago_Pago', label: 'Pacific/Pago Pago (SST)'}
].sort((a, b) => {
    if (a.value == b.value) {
        return 0;
    } else {
        return a.value > b.value ? 1 : -1;
    }
});


export const nihonNoPrefectures = [
    {name: '北海道'},
    {name: '青森県'},
    {name: '岩手県'},
    {name: '宮城県'},
    {name: '秋田県'},
    {name: '山形県'},
    {name: '福島県'},
    {name: '茨城県'},
    {name: '栃木県'},
    {name: '群馬県'},
    {name: '埼玉県'},
    {name: '千葉県'},
    {name: '東京都'},
    {name: '神奈川県'},
    {name: '新潟県'},
    {name: '富山県'},
    {name: '石川県'},
    {name: '福井県'},
    {name: '山梨県'},
    {name: '長野県'},
    {name: '岐阜県'},
    {name: '静岡県'},
    {name: '愛知県'},
    {name: '三重県'},
    {name: '滋賀県'},
    {name: '京都府'},
    {name: '大阪府'},
    {name: '兵庫県'},
    {name: '奈良県'},
    {name: '和歌山県'},
    {name: '鳥取県'},
    {name: '島根県'},
    {name: '岡山県'},
    {name: '広島県'},
    {name: '山口県'},
    {name: '徳島県'},
    {name: '香川県'},
    {name: '愛媛県'},
    {name: '高知県'},
    {name: '福岡県'},
    {name: '佐賀県'},
    {name: '長崎県'},
    {name: '熊本県'},
    {name: '大分県'},
    {name: '宮崎県'},
    {name: '鹿児島県'},
    {name: '沖縄県'},
];
